"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _animations = _interopRequireDefault(require("./animations"));

var _presets = _interopRequireDefault(require("./presets"));

var Styles = _interopRequireWildcard(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function PageTransition(_ref) {
  var children = _ref.children,
      enterAnimationOverride = _ref.enterAnimation,
      exitAnimationOverride = _ref.exitAnimation,
      preset = _ref.preset,
      transitionKey = _ref.transitionKey,
      rest = _objectWithoutProperties(_ref, ["children", "enterAnimation", "exitAnimation", "preset", "transitionKey"]);

  var selectEnterAnimation = function selectEnterAnimation() {
    if (enterAnimationOverride) {
      if (typeof enterAnimationOverride === 'string') {
        return _animations["default"][enterAnimationOverride];
      }

      return _objectSpread({}, _animations["default"][enterAnimationOverride.name], {
        delay: enterAnimationOverride.delay,
        onTop: enterAnimationOverride.onTop
      });
    }

    if (preset) {
      return _objectSpread({}, _animations["default"][_presets["default"][preset].enter.name], {
        delay: _presets["default"][preset].enter.delay,
        onTop: _presets["default"][preset].enter.onTop
      });
    }

    return 'rotateSlideIn';
  };

  var selectExitAnimation = function selectExitAnimation() {
    if (exitAnimationOverride) {
      if (typeof exitAnimationOverride === 'string') {
        return _animations["default"][exitAnimationOverride];
      }

      return _objectSpread({}, _animations["default"][exitAnimationOverride.name], {
        delay: exitAnimationOverride.delay,
        onTop: exitAnimationOverride.onTop
      });
    }

    if (preset) {
      return _objectSpread({}, _animations["default"][_presets["default"][preset].exit.name], {
        delay: _presets["default"][preset].exit.delay,
        onTop: _presets["default"][preset].exit.onTop
      });
    }

    return 'rotateSlideIn';
  };

  var enterAnimation = selectEnterAnimation();
  var exitAnimation = selectExitAnimation();
  var timeout = Math.max(enterAnimation.duration, exitAnimation.duration);
  return _react["default"].createElement(Styles.PageTransitionGroup, rest, _react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
    component: null
  }, _react["default"].createElement(_reactTransitionGroup.Transition, {
    key: transitionKey,
    timeout: timeout
  }, function (state) {
    return _react["default"].createElement(Styles.PageTransition, {
      enterAnimation: enterAnimation,
      exitAnimation: exitAnimation,
      state: state
    }, children);
  })));
}

var _default = (0, _react.memo)(PageTransition);

exports["default"] = _default;